if (!window.__mlCartAjaxBound) {
  window.__mlCartAjaxBound = true;

  (function () {
    'use strict';

    function parseCartPermalink(rawUrl) {
      var decoded = rawUrl;
      for (var i = 0; i < 3; i++) {
        try {
          var next = decodeURIComponent(decoded);
          if (next === decoded) break;
          decoded = next;
        } catch (e) { break; }
      }

      var items = [];
      var itemRe = /items\[(\d+)\]\[([a-zA-Z_]+)\]=([^&]+)/g;
      var m;
      while ((m = itemRe.exec(decoded)) !== null) {
        var idx = parseInt(m[1], 10);
        var key = m[2];
        var val = decodeURIComponent(m[3].replace(/\+/g, ' '));
        items[idx] = items[idx] || {};
        items[idx][key] = (key === 'id' || key === 'quantity' || key === 'selling_plan') && val !== '' && !isNaN(val)
          ? Number(val)
          : val;
      }

      var attributes = {};
      var attrRe = /(?:^|[?&])attributes\[([^\]]+)\]=([^&]+)/g;
      while ((m = attrRe.exec(decoded)) !== null) {
        attributes[decodeURIComponent(m[1])] = decodeURIComponent(m[2].replace(/\+/g, ' '));
      }

      return { items: items.filter(Boolean), attributes: attributes };
    }

    function submitSubscriptionCta(anchorEl) {
      if (!anchorEl || anchorEl.dataset.mlSubmitting === '1') return;
      var fallbackUrl = anchorEl.getAttribute('href');
      if (!fallbackUrl || fallbackUrl === '#') return;

      var parsed = parseCartPermalink(fallbackUrl);
      if (!parsed.items.length) {
        window.location.href = fallbackUrl;
        return;
      }

      anchorEl.dataset.mlSubmitting = '1';
      anchorEl.classList.add('is-loading');

      function fallback(reason) {
        console.warn('[cart-ajax] falling back to permalink:', reason);
        try {
          if (window.posthog) window.posthog.capture('ml_cta_ajax_fallback', { reason: String(reason) });
        } catch (e) {}
        window.location.href = fallbackUrl;
      }

      function withTimeout(promise, ms) {
        return Promise.race([
          promise,
          new Promise(function (_, reject) { setTimeout(function () { reject(new Error('timeout')); }, ms); }),
        ]);
      }

      withTimeout(fetch('/cart/clear.js', { method: 'POST', credentials: 'same-origin' }), 4000)
        .then(function (res) {
          if (!res.ok) throw new Error('clear.js ' + res.status);
          return withTimeout(
            fetch('/cart/add.js', {
              method: 'POST',
              credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: parsed.items }),
            }),
            4000
          );
        })
        .then(function (res) {
          return res.json().then(function (body) {
            if (!res.ok || body.status === 422 || body.description) {
              throw new Error('add.js ' + res.status + ': ' + (body.description || body.message || 'unknown'));
            }
            return body;
          });
        })
        .then(function () {
          var keys = Object.keys(parsed.attributes);
          if (!keys.length) return null;
          return withTimeout(
            fetch('/cart/update.js', {
              method: 'POST',
              credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ attributes: parsed.attributes }),
            }),
            4000
          );
        })
        .then(function () {
          window.location.href = '/checkout';
        })
        .catch(function (err) {
          fallback(err && err.message ? err.message : err);
        });
    }

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest(
        '#v4-add-to-cart, #v5-add-to-cart, #v6-add-to-cart, #v7-checkout-btn, #v8-add-to-cart, #v9-add-to-cart, [data-ml-subscribe-cta]'
      );
      if (!trigger) return;
      e.preventDefault();
      submitSubscriptionCta(trigger);
    });
  })();
}